export default __webpack_public_path__ + "static/media/guidelineFestival.ae092573.png";